export default __webpack_public_path__ + "static/media/img10.2101d341.jpg";